export default "__VITE_ASSET__B6e4gE0r__"